const GOOGLE_AUTH_URL = "/google/auth-url";
const GOOGLE_CALLBACK = "/google/callback";

export const google = { GOOGLE_AUTH_URL, GOOGLE_CALLBACK };


